import { Collapsed } from "components";
import { buildTestIds } from "application";
import { Title, Description } from "./styles";

interface params {
  productDetails: string;
  idSection: string;
  isBlackTheme?: boolean;
}

const AboutTheProduct = ({
  productDetails,
  idSection,
  isBlackTheme,
}: params) => {
  return (
    <Collapsed
      id={idSection}
      isBlackTheme={isBlackTheme}
      titleComponent={
        <Title
          {...buildTestIds("about-the-product-title")}
          isBlackTheme={isBlackTheme}
        >
          Sobre o produto
        </Title>
      }
    >
      <Description
        isBlackTheme={isBlackTheme}
        {...buildTestIds("about-the-product-description")}
        dangerouslySetInnerHTML={{ __html: productDetails }}
      />
    </Collapsed>
  );
};

export default AboutTheProduct;
